<div class="ui-modal">
    <div class="header flex-row space-between-center">
        {{'FLOW_CHART.INPUT_DIALOG.NAME'|translate}}
        <span class="ui-icon-close c-p"
              mat-dialog-close>
        </span>
    </div>

    <div class="body">
        <div class="flex-col h-100 w-100 gap-8 mt-16">
            <div class="virtual-scroll-container w-100"
                 [class.invalid]="message.invalid">
                <section class="virtual-scroll-table w-100 flex-col gap-8">
                    <header>
                        <div class="col flex">
                            <div class="inner">
                                    {{ 'FLOW_CHART.INPUT_DIALOG.CONTROL_NAME'|translate }}
                                    <span class="required">*</span>
                            </div>
                        </div>
                        <div class="col flex">
                            <div class="inner">

                            </div>
                        </div>
                        <div class="col flex"
                             style="max-width: 50px;">
                            <div class="inner">
                            </div>
                        </div>
                    </header>
                    <div class="w-100"
                         style="height:200px">
                        <ngx-monaco-editor (onInit)="onEditorInit($event)"
                                           [options]="editorOptions()"
                                           class="w-100 h-100"
                                           [formControl]="message">
                        </ngx-monaco-editor>
                    </div>
                </section>

            </div>
        </div>
    </div>

    <div class="footer flex-row end-center">
        <ui-button type="default"
                   [text]="'COMMON.CANCEL'|translate"
                   (clickAction)="close()">
        </ui-button>

        <ui-button type="primary"
                   [text]="'FLOW_CHART.EXECUTE_GRAPG'|translate"
                   (clickAction)="save()">
        </ui-button>
    </div>
</div>